import { useNavigate } from 'react-router-dom';
import Profile from "../../auth/profile/Profile";
import AutoCompleteComponent from "../../stories/autocomplete/AutoComplete"
import { useMercuryContext } from 'context/index';
import { useMemo } from 'react';

interface RightMenuProps {
  adminMenuData: {
    handleMainMenuSelection: (menu: string) => void;
  };
  drawOpen?: boolean;
}

const RightMenu: React.FC<RightMenuProps> = ({ adminMenuData }) => {
  const { selectedApp, userDetails, gpSocket } = useMercuryContext(),
  navigate = useNavigate();

  const selectedAppName = useMemo(() => {
    if (!selectedApp || !userDetails?.customerApplicationDetails || userDetails?.customerApplicationDetails?.length === 0) return null;
    return userDetails?.customerApplicationDetails.find((a:any) => a._id === selectedApp)?.name || null;
  }, [selectedApp, userDetails?.customerApplicationDetails]);
  
  return (
    <div className="right-menu-container">
      { selectedAppName === "Google" && <AutoCompleteComponent
        emit={"autocomplete"}
        socket={gpSocket?.project}
        handleMainMenuSelection={adminMenuData.handleMainMenuSelection}
        navigate={navigate}
      /> }
      <Profile
        adminData={adminMenuData}
        handleMainMenuSelection={adminMenuData.handleMainMenuSelection}
        selectedAppName={selectedAppName}
      />
    </div>
  );
};

export default RightMenu;
